import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { environment } from '@rocksoft/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeatureGuard {
  canActivate: CanActivateFn = (
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> => {
    const url = state.url;

    if (url.includes('/mdm/settings')) {
      return this.isSettingsEnabled();
    }
    if (url.includes('/mdm/device-updates')) {
      return this.isDeviceUpdatesEnabled();
    }
    if (url.includes('/mdm/dep')) {
      return this.isDepEnabled();
    }
    return true;
  };

  private isSettingsEnabled(): boolean {
    return environment.features.devices.details.settings.enabled;
  }

  private isDeviceUpdatesEnabled(): boolean {
    return environment.features.deviceupdates.enabled;
  }

  private isDepEnabled(): boolean {
    return environment.features.gateway.enabled && environment.features.dep.enabled;
  }
}
